import { CustomArray } from "./BaseModel";

export class Service {
  constructor(
    public readonly id: string,
    public readonly name: string,
    public readonly description: string,
  ) {
  }
}

export class Services extends CustomArray<Service> {
  getById(id: string): Service | undefined {
    return this.find((service) => service.id === id);
  }

  nameMap(): { [key: string]: string; } {
    const map: { [key: string]: string; } = {};
    this.forEach((service) => {
      map[service.id] = service.name;
    });
    return map;
  }
}
